export default __webpack_public_path__ + "stroke-width-2.asset.49293a0f855ac4bde9eba036fb293b5c.svg";